import { createStore } from 'zustand/vanilla';

import type {
	CountStoreState,
	EmailBodyStoreState,
	EnquiriesSearchStoreState,
	EnquiriesSelectStoreState,
	EnquiriesStoreState,
	MarkAsContactedStoreState,
	ModalFlowStoreState,
	ModalStoreState,
	ProcessingEmailsStoreState,
	StatusStoreState,
} from './types';
import { ModalSteps } from './types';

export const ModalStore = createStore<ModalStoreState>(() => ({
	isOpen: false,
}));

export const ModalFlowStore = createStore<ModalFlowStoreState>(() => ({
	currentStep: ModalSteps.EnquirySelectionLoading,
}));

export const CountStore = createStore<CountStoreState>(() => ({
	unsentMessagesCount: '',
}));

export const StatusStore = createStore<StatusStoreState>(() => ({
	enquiryIds: [],
	statuses: {},
}));

export const EnquiriesStore = createStore<EnquiriesStoreState>(() => ({
	enquiries: [],
	enquiriesMap: {},
	hasMoreItems: false,
}));

export const EnquiriesSearchStore = createStore<EnquiriesSearchStoreState>(() => ({
	filteredSaleIds: {},
	keyword: '',
	noResults: false,
	search: '',
}));

export const EnquiriesSelectStore = createStore<EnquiriesSelectStoreState>(() => ({
	interactedSaleIds: {},
	selectedSaleIds: [],
}));

export const EmailBodyStore = createStore<EmailBodyStoreState>(() => ({
	body: '',
	bodyError: null,
	isBodyEmpty: true,
	saveAsDefaultBody: false,
	templateId: '',
}));

export const ProcessingEmailsStore = createStore<ProcessingEmailsStoreState>(() => ({
	errorGroups: [],
	result: {
		failedToUpdateSales: [],
		updatedSaleIds: [],
	},
}));

export const MarkAsContactedStore = createStore<MarkAsContactedStoreState>(() => ({
	errorGroups: [],
	result: {
		failedToUpdateSales: [],
		updatedSales: [],
	},
}));
